
import { backendUrl } from '../util/endpointConfig'
import { language } from '../util/language'

export default function getDeliveryTimes() {
    return fetch(backendUrl+'services/deliveryTime/all/' + language, 
    { method: 'GET' })
    .then(ans => ans.json())
    .then(response => response);
}

